export default {
  "players/classic": {
    en: "Classic",
    fr: "Classique",
  },
  "players/rapid": {
    en: "Rapid",
    fr: "Rapide",
  },
  "players/username": {
    en: "Username",
    fr: "Bon d'utilisateurice",
  },
  "players/search": {
    en: "Search",
    fr: "Recherchez",
  },
  "players/find": {
    en: "Find player",
    fr: "Trouver un·e partenaire",
  },

  "players/ai": {
    en: "Play with Lichess AI",
    fr: "Jouer avec l'automate",
  },

  "players/ai-level": {
    en: "Level",
    fr: "Niveau",
  },

  "players/following": {
    en: "Players you follow",
    fr: "Les joueur·euses que vous suivez ",
  },
};
